import {Pipe, PipeTransform} from "@angular/core";
import {UserService} from "../../service/user.service";
import {GroupEnum} from "../../shared/enums/group.enum";

@Pipe({
  name: 'desabilitaFrameworkNoHub',
  standalone: true,
})
export class DesabilitaFrameworkNoHubPipe implements PipeTransform {

  transform(userService: UserService): boolean {
    const apresentaHubSemPermitirFramework = [
      GroupEnum.ECO50,
    ];
    const user = userService.user;
    if (!user || !user.groups) {
      return false;
    }

    return user.groups.filter(group => apresentaHubSemPermitirFramework.includes(group.id ?? -1))
      .length === 0;
  }

}
